import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface CustomOrderApiParameter extends ApiParameter {
    ProductNumber?: string;
    Shape?: string;
    WidthFeet?: number;
    WidthInches?: number;
    LengthFeet?: number;
    LengthInches?: number;
    SideFeet?: number;
    Sideinches?: number;
    DiameterFeet?: number;
    DiameterInches?: number;
    PoNumber: string;
    Sidemark: string;
    Quantity: number;
    Description?: string;
    Price?: string;
    CustomSize: string;
    LeadTime: string;
    Comment: string;
    Signature?: string;
    QuoteDate: string;
    ItemPrice: string;
    CheckNumber: string;
    PaymentType: string;
    STCompanyName: string;
    STAddress1: string;
    STAddress2: any;
    STAddress3: any;
    STPostalCode: string;
    STCity: string;
    STState: string;
    STCountry: string;
    STPhoneNo: string;
    EmailList: string;
    Subject: string;
}

export interface CustomOrderApiModel extends ApiParameter {
    ProductNumber: string;
    Shape: string;
    WidthFeet: number;
    WidthInches: number;
    LengthFeet: number;
    LengthInches: number;
    SideFeet: number;
    Sideinches: number;
    DiameterFeet: number;
    DiameterInches: number;
    PoNumber: string;
    Sidemark: string;
    Quantity: number;
    Description: string;
    Price: string;
    CustomSize: string;
    LeadTime: string;
    Comment: string;
    Signature: string;
    QuoteDate: string;
    ItemPrice: string;
    CheckNumber: string;
    PaymentType: string;
    STCompanyName: string;
    STAddress1: string;
    STAddress2: any;
    STAddress3: any;
    STPostalCode: string;
    STCity: string;
    STState: string;
    STCountry: string;
    STPhoneNo: string;
}
const customUrl = "/api/v2/requestquote/customorder";

export function CustomOrderService(
    parameter: CustomOrderApiParameter & HasOnSuccess<CustomOrderApiParameter> & HasOnComplete<CustomOrderApiParameter>,
) {
    const apiParameter = { ...parameter };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;
    return post<CustomOrderApiParameter>(customUrl, apiParameter);
}
